export const projects = "/projects";

export const theStudio = "/the-studio";

export const contact = "/contact";

// Projects
export const tractify = process.env.NEXT_PUBLIC_TRACTIFY || "";
export const stellaDaniels = process.env.NEXT_PUBLIC_STELLA_DANIELS || "";
export const uwa = process.env.NEXT_PUBLIC_UWA || "";
export const denim = process.env.NEXT_PUBLIC_DENIM || "";
export const luxeMoissanite = process.env.NEXT_PUBLIC_LUXE_MOISSANITE || "";
export const wiseStore = process.env.NEXT_PUBLIC_WISE_STORE || "";
export const capitalFlow = process.env.NEXT_PUBLIC_CAPITAL_FLOW || "";

// Case Studies
export const casaDeKairos = `${projects}/case-studies/casa-de-kairos`;
export const riftAI = `${projects}/case-studies/rift-ai`;

// Social Links
export const linkedin = "https://www.linkedin.com/company/theparallellab/";
export const contra = "https://contra.com/parallel_lab";
export const twitter = "https://x.com/theparallellab";
export const instagram = "https://instagram.com/theparallellab";